import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";

import { text } from "../text";
import { hooks } from "../hooks";
import { utils } from "../utils";
import { theme } from "../constants";
import { components } from "../components";
interface Notification {
  id: number;
  icon: string;
  heading: string;
  description: string;
  time: string;
}

const notifications: Notification[] = [
  {
    id: 1,
    icon: "💬",
    heading: "Talk to Your Landlord",
    description: "Ask your landlord about loans on rent and security deposit.",
    time: "6 hours ago",
  },
  {
    id: 2,
    icon: "📝",
    heading: "Update Your Profile",
    description:
      "Complete your profile details to get better PG recommendations.",
    time: "1 day ago",
  },
  {
    id: 3,
    icon: "📱",
    heading: "Verify Your Mobile",
    description:
      "Verify your mobile number to receive instant booking updates.",
    time: "2 days ago",
  },
  {
    id: 4,
    icon: "🏠",
    heading: "Check New Properties",
    description:
      "Explore newly added PGs near your college and save your favorites.",
    time: "3 days ago",
  },
  {
    id: 5,
    icon: "💰",
    heading: "Rent Payment Reminder",
    description:
      "Your monthly rent is due soon. Pay on time to avoid late charges.",
    time: "5 days ago",
  },
];

const NotificationPage1: React.FC = () => {
  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title="Notifications"
        goBack={true}
        skip={false}
        clear={false}
        clearOnClicked={() => {}}
      />
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <div className="notification-container">
        {notifications?.map((notification) => (
          <div key={notification.id} className="notification-card">
            <div style={{ display: "flex" }}>
              <div className="notification-icon-wrapper">
                {notification.icon}
              </div>
              <div
                className="notification-content"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="notification-title">{notification.heading}</div>
                <div className="notification-meta">
                  <span className="notification-time">{notification.time}</span>
                </div>
              </div>
            </div>

            <div className="notification-text">{notification.description}</div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      {renderHeader()}
      <div
        className=""
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: "100vh",
          paddingBottom: 20,
          marginTop: 70,
        }}
      >
        {renderContent()}
      </div>
    </>
  );
};
export default NotificationPage1;

// const notifications: Notification[] = [
//   {
//     id: 1,
//     icon: '🔔',
//     heading: 'New Feature Added!',
//     description: 'We have added a new feature that you will love! Check it out now.',
//     time: '2 hours ago',
//   },
//   {
//     id: 2,
//     icon: '⚡',
//     heading: 'System Maintenance',
//     description: 'Our servers will undergo maintenance from 3:00 AM to 5:00 AM.',
//     time: '1 day ago',
//   },
//   {
//     id: 3,
//     icon: '📣',
//     heading: 'New Update Available',
//     description: 'A new update is available for the app. Update now to enjoy the new features.',
//     time: '3 days ago',
//   },
//   // Add more notifications here
// ];

// const renderContent = (): JSX.Element => {
//   return (
//     <div className="notification-page">

//       <div className="notification-list">
//         {notifications.map((notification) => (
//           <div key={notification.id} className="notification-item">
//             <div className="notification-left">
//               {/* Icon */}
//               <div className="notification-icon">{notification.icon}</div>
//             </div>

//             <div className="notification-center">
//               {/* Heading */}
//               <div className="notification-heading">{notification.heading}</div>
//               {/* Description */}
//               <div className="notification-description">{notification.description}</div>
//             </div>

//             <div className="notification-right">
//               {/* Time */}
//               <div className="notification-time">{notification.time}</div>
//             </div>
//           </div>
//         ))}
//       </div>

//       <style>{`
//       .notification-page {
//         font-family: Arial, sans-serif;
//         padding: 20px;
//       }

//       .notification-list {
//         display: flex;
//         flex-direction: column;
//         gap: 16px;
//       }

//       .notification-item {
//         display: flex;
//         justify-content: space-between;
//         align-items: flex-start;
//         padding: 12px;
//         border: 1px solid #ddd;
//         border-radius: 8px;
//         background-color: #f9f9f9;
//       }

//       .notification-left {
//         flex: 0 0 40px;
//         display: flex;
//         justify-content: center;
//         align-items: center;
//       }

//       .notification-icon {
//         font-size: 24px;
//       }

//       .notification-center {
//         flex: 1;
//         padding: 0 16px;
//       }

//       .notification-heading {
//         font-weight: bold;
//         font-size: 16px;
//         color: #333;
//       }

//       .notification-description {
//         font-size: 14px;
//         color: #666;
//       }

//       .notification-right {
//         flex: 0 0 80px;
//         display: flex;
//         justify-content: flex-end;
//         align-items: center;
//       }

//       .notification-time {
//         font-size: 12px;
//         color: #999;
//       }

//       .notification-item:hover {
//         background-color: #f0f0f0;
//         cursor: pointer;
//       }
//     `}</style>
//     </div>
//   );
// };

// const renderContent = (): JSX.Element => {
//   return (
//     <div className="notification-container">
//       {notifications.map((notification) => (
//         <div key={notification.id} className="notification-card">
//           <div className="notification-icon-wrapper">
//             {notification.icon}
//           </div>
//           <div className="notification-content">
//             <div style={{ display: "flex", justifyContent: "space-between" }}>
//               <div className="notification-title">{notification.heading}</div>
//               <div className="notification-meta">
//                 <span className="notification-time">{notification.time}</span>
//               </div>
//             </div>
//             <div className="notification-text">{notification.description}</div>
//           </div>

//         </div>
//       ))}
//     </div>
//   );
// };
 